import React from "react";
import { ChartsSetWrapperNew } from "../../../../../components";
import { chartAdvDataNew } from "./data";

const BarListAdv = () => {
  return (
    <div className="grid">
      <ChartsSetWrapperNew
        title="Bar Chart"
        type="bar"
        data={chartAdvDataNew.series}
        categories={chartAdvDataNew.categories}
        options={{
          bar: {
            stacked: true,
          },
        }}
      />
    </div>
  );
};

export default BarListAdv;
